import React, { useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem, Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';

import CardSupplier from '@/main/components/shared/cardSupplier/cardSupplier';
import ColumnLabel from '@/main/components/common/columnLabel/columnLabel';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import TooltipComponent from '@/main/components/shared/tooltip/tooltipComponent';
import { Spinner } from '@/main/components/shared/inputAutoComplete/styles';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';

import { IGetPackageDetailsResponse } from '@/main/models/response';

import colors from '@/main/style/colors';

import * as S from './styles';
import {
  handleDownloadPDf,
  handleDownloadZPL
} from '../../../viewOrder/components/infoOrder/utilsInfoOrder';

interface IInfoOrderProps {
  guidCompany: string;
  dataManagePackages: IGetPackageDetailsResponse | null;
  isLoadingOrder: boolean;
  trackingCode: number;
  isManagePackages?: boolean;
}
const INITIAL_STATE_EDIT_PART = {
  isOpen: false as boolean,
  guidQuoteProcurement: null as string | null,
  guidProcurementSupplierItem: null as string | null
};
export type InitialStateEditPart = typeof INITIAL_STATE_EDIT_PART;

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiPaper-root': {
      backgroundColor: colors.white
    }
  }
}));

const useStylesTooltip = makeStyles({
  popperCustom: { marginLeft: 15 }
});

function InfoOrder({
  guidCompany,
  dataManagePackages,
  isLoadingOrder,
  trackingCode
}: IInfoOrderProps) {
  const classesTooltip = useStylesTooltip();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [loadingZpl, setLoadingZpl] = useState<boolean>(false);
  const [loadingPdf, setLoadingPdf] = useState<boolean>(false);

  const classes = useStyles();

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <S.Container>
      {isLoadingOrder ? (
        <LoadingComponent />
      ) : (
        <>
          <S.Header>
            <S.RowFlexInfoOrder>
              <S.AreaInfoOrder>
                <ColumnLabel
                  label={getTranslateByKey('information.createDate')}
                  content={dataManagePackages?.createdDateFormatted}
                />
                <ColumnLabel
                  label={getTranslateByKey('information.licensePlate')}
                  content={dataManagePackages?.licensePlate || '-'}
                />
                <ColumnLabel
                  label={getTranslateByKey('information.packageDimensions')}
                  content={`${dataManagePackages?.height} x ${dataManagePackages?.width} x ${dataManagePackages?.depth}`}
                />
                <ColumnLabel
                  label={getTranslateByKey('information.scheduledCollection')}
                  content={`${dataManagePackages?.dateScheduledCollection} - ${dataManagePackages?.timeScheduledCollection}`}
                />
                <ColumnLabel
                  label={getTranslateByKey('information.deadline')}
                  content={dataManagePackages?.deadlineDateFormatted}
                />
              </S.AreaInfoOrder>
              {!isNullUndefined(trackingCode) &&
                !dataManagePackages?.isDeliveredBySupplier && (
                  <S.AreaButton>
                    <TooltipComponent
                      title={`${getTranslateByKey(
                        'information.clickToSeeTheActions'
                      )}`}
                      placement="top"
                      stylePopper={classesTooltip.popperCustom}>
                      <S.ButtonTrigger type="button" onClick={handleClick}>
                        <MoreVertIcon
                          className="ignore-click"
                          id="id-infoManagePackages-icon-threeDots"
                        />
                      </S.ButtonTrigger>
                    </TooltipComponent>
                    {anchorEl !== null && (
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        elevation={2}
                        MenuListProps={{
                          'aria-labelledby': 'basic-button'
                        }}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'center'
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right'
                        }}
                        className={classes.root}
                        style={{ zIndex: 1 }}>
                        <MenuItem
                          onClick={() => {
                            !loadingPdf &&
                              handleDownloadPDf(trackingCode, setLoadingPdf);
                          }}>
                          <Divider />
                          {getTranslateByKey('information.printPDFTag')}
                          {loadingPdf && (
                            <Spinner style={{ margin: '0 -10px 0 10px' }} />
                          )}
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            !loadingZpl &&
                              handleDownloadZPL(trackingCode, setLoadingZpl);
                          }}>
                          {getTranslateByKey('information.printZPLTag')}
                          {loadingZpl && (
                            <Spinner style={{ margin: '0 -10px 0 10px' }} />
                          )}
                        </MenuItem>
                      </Menu>
                    )}
                  </S.AreaButton>
                )}
            </S.RowFlexInfoOrder>
          </S.Header>
          <p>{getTranslateByKey('information.parts')}</p>
          <S.Content>
            {dataManagePackages && (
              <CardSupplier
                key={dataManagePackages?.guidPackingTracking}
                guidCompany={guidCompany}
                supplierName={dataManagePackages?.supplierCompanyName}
                isFavoriteProp={false}
                deliveryBySupplier={dataManagePackages?.isDeliveredBySupplier}
                supplierItems={dataManagePackages?.partsPackage}
                shippingCost={dataManagePackages?.shippingCost}
                itemTotalCost={dataManagePackages?.totalPrice}
                guidProcurementSupplier={
                  dataManagePackages?.guidPackingTracking
                }
                isManagePackages
              />
            )}
          </S.Content>
        </>
      )}
    </S.Container>
  );
}

export default InfoOrder;
